import React, {useEffect, useState, useRef} from "react";

const Slideshow = ({content}) => {
    const [index, setIndex] = useState(0);
    const delay = 4000
    const timoutRef = useRef(null);

    const resetTimeout = () => {
        if (timoutRef.current) {
            clearTimeout(timoutRef.current)
        }
    }

    useEffect(() => {
        timoutRef.current = setTimeout(
            () => setIndex((prevIndex) =>
            prevIndex === content.length - 1 ? 0 : prevIndex + 1), delay
        );

        return () => {
            resetTimeout();
        };
    },[index]);

    return (
        <div className="slideshow" >
        <div className="slideshow-slider"
        style={{transform: `translate3d(${-index * 100}%, 0, 0)`}}>
            {content.map((picture, index) => {
                return (
                    <div className="slide" key={index}>
                        <h1 id="title">{picture.title}</h1>
                        <img src={picture.url} alt="Anime pictures" className="pictures"></img>
                    </div>
                )
            })}
        </div>
    </div>
    )
}

export default Slideshow;